module.exports = __webpack_public_path__ + "img/f5edd096095345f59090fa41053e6963-60.0115262e.png";